import Vue from 'vue';
import Skeleton from 'vue-loading-skeleton';
import "vue-loading-skeleton/dist/vue-loading-skeleton.css"

Vue.use(Skeleton)